import React from "react";
import { Box } from "@mui/joy";
import { useDrawer } from "../Drawer";
import { useString } from "src/mtska-frontend-app-component/utils";


const CampaignAvatar = ({ size = "default", url = null, withname = false, name = null, detail = null, item }) => {

    const { firstCharacter, toColor } = useString();
    const apiBasePath = process.env.REACT_APP_API_ENDPOINT || '';

    return (
        <Box className={"campaign-avatar-wrapper campaign-avatar-withname-" + withname}>
            <Box className={"campaign-avatar campaign-avatar-" + size} style={{ backgroundColor: toColor(name) }}>
                {url && (
                    <img src={url} />
                )}
                {!url && (
                    (firstCharacter(name).toUpperCase())
                )}
            </Box>
            {withname === true && (
                <Box className={"campaign-name" + (detail ? " hasdetail" : "")}>
                    {name ? (
                        <span className="name" title={name}>{name}</span>
                    ) : (
                        <div className="skeleton skeleton-text" style={{ width: 120, height: 20 }} />
                    )}
                    {detail && (
                        <span className="detail">{(detail)}</span>
                    )}
                </Box>
            )}
        </Box>
    )
}

export default CampaignAvatar;